<template>
  <v-dialog v-model="surveyDialog" width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on">
        {{ $t("surveys.surveys.personalResp") }}
      </v-btn>
    </template>
    <v-card v-if="survey">
      <div class="header primary white--text px-3">
        <div class="d-flex justify-space-between align-center">
          <v-card-title class="pb-0"
            >{{ survey.type | capitalize }}: {{ survey.name }}</v-card-title
          >
          <v-btn icon @click="close">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="subtitle-1 py-0"
          >{{ totalAnswers }} {{ $t("surveys.SurveyResponseDialog.totalAnswer") }}</v-card-title
        >
      </div>

      <v-card-text v-if="responses">
        <div class="d-flex flex-row mt-4">
          <v-avatar size="50">
            <v-img :src="currentTraveler.pic || require('@/assets/profile_pic_empty.png')"></v-img>
          </v-avatar>
          <div class="ml-4">
            <p>
              <span class="title">{{ currentTraveler.name }}</span>
              <br />
              {{ currentTraveler.email }}
            </p>
          </div>
          <v-spacer></v-spacer>
          <v-card v-if="survey.type == 'quiz'" class="ml-6 mb-4">
            <!-- <v-card-title></v-card-title> -->
            <v-card-text class="text-center py-2 px-4">
              <span class="title">{{ $t("surveys.SurveyResponseDialog.score") }}</span>
              <br />
              <span class="headline">{{ quizScore }}</span>
              <br />
              {{ correctResponses }}/{{ survey.questions.length }}
            </v-card-text>
          </v-card>
        </div>

        <div class="pa-1 overflow-y-auto" v-if="survey.type == 'quiz'" style="max-height: 50vh">
          <v-card class="my-2" v-for="(question, index) in survey.questions" :key="index">
            <v-card-title :class="`pb-0 ${correctQuestion(index) ? 'green' : 'red'}--text`">
              {{ index + 1 }}.-
              {{ question.question }}
              <v-icon class="ml-2" :color="correctQuestion(index) ? 'green' : 'red'">{{
                correctQuestion(index) ? "mdi-check" : "mdi-close"
              }}</v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group readonly :value="travelerResponse[index]">
                <v-radio
                  v-for="(option, r) in survey.questions[index].options"
                  :color="correctQuestion(index) ? 'green' : 'red'"
                  :key="r"
                  :label="option"
                  class="rounded-xl"
                  :style="`padding:4px; ${
                    correctQuestion(index) && survey.questions[index].answer == r
                      ? 'background-color:#E8F5E9;'
                      : !correctQuestion(index) && travelerResponse[index] == r
                      ? 'background-color:#FFEBEE;'
                      : !correctQuestion(index) && survey.questions[index].answer == r
                      ? 'background-color:#E3F2FD;'
                      : ''
                  }`"
                ></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </div>
        <div class="pa-1 overflow-y-auto" v-else style="max-height: 50vh">
          <v-card
            max-height="50vh"
            class="my-2"
            v-for="(question, index) in survey.questions"
            :key="index"
          >
            <v-card-title class="pb-0">{{ index + 1 }}.- {{ question.question }}</v-card-title>
            <v-card-text>
              <v-radio-group readonly :value="travelerResponse[index]">
                <v-radio
                  v-for="(option, r) in survey.questions[index].options"
                  :key="r"
                  :value="r"
                  :label="option"
                >
                </v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" v-show="responseIndex > 0" @click="responseIndex--">{{
          $t("common.previous")
        }}</v-btn>
        <v-btn class="primary" v-show="responseIndex < totalAnswers - 1" @click="responseIndex++">{{
          $t("common.next")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["surveyId"],
  data: () => ({
    surveyDialog: false,
    responses: null,
    responseIndex: 0,
  }),
  computed: {
    survey() {
      if (this.$props.surveyId) return this.$store.state.trip.surveys[this.$props.surveyId];
      return null;
    },
    totalAnswers() {
      return Object.keys(this.survey.responses).length;
    },
    travelerResponse() {
      return this.survey.responses[this.responses[this.responseIndex]];
    },
    correctResponses() {
      let score = 0;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.survey.questions.length; i++) {
        if (this.correctQuestion(i)) {
          score += 1;
        }
      }
      return score;
    },
    quizScore() {
      return Math.round((this.correctResponses * 100) / this.survey.questions.length);
    },
    currentTraveler() {
      const traveler = this.$store.getters.getUserById(this.responses[this.responseIndex]);
      return {
        id: traveler.id,
        name: traveler.name,
        email: traveler.email,
        pic: this.$store.getters.getImageUrlById(this.responses[this.responseIndex]),
      };
    },
  },
  methods: {
    close() {
      this.surveyDialog = false;
      this.$emit("closed");
    },
    correctQuestion(question) {
      return this.travelerResponse[question] === this.survey.questions[question].answer;
    },
  },
  created() {
    if (this.$props.surveyId != null) {
      // this.surveyDialog = true;
      this.responses = Object.keys(this.survey.responses);
    }
  },
  watch: {
    surveyId(surveyId, oldsurveyId) {
      console.log("surveyId changed", surveyId);
      if (surveyId && surveyId !== oldsurveyId) {
        // this.surveyDialog = true;
        this.responses = Object.keys(this.survey.responses);
        this.responseIndex = 0;
        console.log("showing dialog");
      }
    },
    // surveyDialog(open) {
    //   if (!open) {
    //     this.$emit("closed");
    //   }
    // },
  },
  filters: {
    capitalize: (value) => {
      if (!value) return "";
      const val = value.toString();
      return val.charAt(0).toUpperCase() + val.slice(1);
    },
  },
};
</script>
